import React from "react";
import styles from "../../css/AppendReplace.module.css";
import { CloseButton } from "../../fixedassetelements/button/Button";

const AppendReplacePopup = ({ onClose, onSelectUploadType }) => {
  const handleCardClick = (type) => {
    onSelectUploadType(type);
    onClose(); 
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <h2 className={styles.title}>Upload Receivable Register</h2>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.content}>
          <div
            className={styles.cardContainer}
            onClick={() => handleCardClick("append")}
          >
            <div className={styles.imageWrapper}>
              <div className={styles.iconPlaceholder}></div>
            </div>
            <div className={styles.belowContainer}>
              <h3 className={styles.cardTitle}>Append File</h3>
              <p className={styles.cardDescription}>
                Lorem ipsum dolor sit amer consectetur.
                <br />
                Vitae lectus dignissim mauris orci
              </p>
            </div>
          </div>

          <div
            className={styles.cardContainer}
            onClick={() => handleCardClick("replace")}
          >
            <div className={styles.imageWrapper}>
              <div className={styles.iconPlaceholder}></div>
            </div>
            <div className={styles.belowContainer}>
              <h3 className={styles.cardTitle}>Replace File</h3>
              <p className={styles.cardDescription}>
                Lorem ipsum dolor sit amer consectetur.
                <br />
                Vitae lectus dignissim mauris orci
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppendReplacePopup;